import React, { useContext, useEffect, useState } from "react";
import { NotificacionContext } from "../context/notificacion_context";
import { services } from "../services/api";
import IconUI from "../components/ui/icon_ui";
import { AiOutlineEdit } from "react-icons/ai";
import DeleteIcon from "@mui/icons-material/Delete";

export const useOficinas = () => {
  const urlGetOfi = "catalago/OFICINA";
  const urlGetMun = "catalago/MUNICIPIO";
  const urlPostOfi = "catalogo/alta-oficina";
  const urlPutOfic = "catalogo/editar-oficina";
  const urlDelOfic = "catalogo/eliminar-oficina";
  const notification = useContext(NotificacionContext);
  const [state, setState] = useState({
    showModal: false,
    showModalDel: false,
    isEditing: false,
    municipioSelected: "",
    municipioFilter: "",
    idOficina: "",
    oficina: "",
    claveOficina: "",
    oficinaDel: "",
    oficinas: [],
    municipios: [],
  });
  const [loader, setLoader] = useState(false);

  const columns = [
    {
      name: "IDENTIFICADOR",
      label: "Clave",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (index) => (
          <div
            style={{ height: "60px" }}
            className={
              index % 2 === 0
                ? "w-100 d-flex align-items-center justify-content-center bg-rosaClaro "
                : "w-100 d-flex justify-content-center align-items-center "
            }
          >
            {state.oficinas[index].IDENTIFICADOR}
          </div>
        ),
      },
    },
    {
      name: "DESCRIPCION",
      label: "Oficina",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (index) => (
          <div
            style={{ height: "60px" }}
            className={
              index % 2 === 0
                ? "w-100 d-flex align-items-center justify-content-center bg-rosaClaro "
                : "w-100 d-flex justify-content-center align-items-center "
            }
          >
            {state.oficinas[index].DESCRIPCION}
          </div>
        ),
      },
    },
    {
      name: "MUNICIPIO",
      label: "Municipio",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (index) => (
          <div
            style={{ height: "60px" }}
            className={
              index % 2 === 0
                ? "w-100 d-flex align-items-center justify-content-center bg-rosaClaro "
                : "w-100 d-flex justify-content-center align-items-center "
            }
          >
            {state.oficinas[index].MUNICIPIO}
          </div>
        ),
      },
    },
    {
      name: "acciones",
      label: "Acciones",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (index) => (
          <div
            style={{ height: "60px" }}
            className={
              index % 2 === 0
                ? "w-100 d-flex align-items-center justify-content-center bg-rosaClaro "
                : "w-100 d-flex justify-content-center align-items-center "
            }
          >
            {validarEdicion(index)}
          </div>
        ),
      },
    },
  ];

  const options = {
    selectableRows: "none",
    fixedHeader: true,
    tableBodyHeight: "650px",
    tableBodyMaxHeight: "650px",
    responsive: "standard",
    textLabels: {
      body: {
        noMatch: "Lo sentimos, no hay coincidencias en la busqueda",
        toolTip: "Clasificar",
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtrar tabla",
      },
      filter: {
        all: "Todo",
        title: "Filtros",
        reset: "Restaurar",
      },
      viewColumns: {
        title: "Ver columnas",
        titleAria: "Mostrar/Ocultar columnas en la tabla",
      },
      selectedRows: {
        text: "columna(s) selecciona(as)",
        delete: "Eliminar",
        deleteAria: "Eliminar filas seleccionadas",
      },
    },
    downloadOptions: {
      filename: "tablaOficinas.csv",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: false,
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      const csv = buildHead(columns) + buildBody(data);
      const BOM = "\uFEFF";
      const blob = new Blob([BOM + csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "tablaOficinas.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return false;
    },
    searchText: "",
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async (municipio = null) => {
    let urlAux = urlGetOfi;
    if (municipio) urlAux = urlGetOfi + `/${municipio}`;
    try {
      setLoader(true);
      const [oficinasRes, municipiosRes] = await Promise.all([
        services("GET", urlAux),
        services("GET", urlGetMun),
      ]);
      const oficinas = oficinasRes?.data?.TB_RESULTADO || [];
      const municipios = municipiosRes?.data?.TB_RESULTADO || [];
      municipios.unshift({
        IDENTIFICADOR: null,
        DESCRIPCION: "TODAS",
      });
      setState((prevState) => ({
        ...prevState,
        oficinas: oficinas.reverse(),
        municipios: municipios,
      }));
    } catch (error) {
      console.error("Error al cargar datos:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleCreate = async () => {
    if (!state.oficina || !state.claveOficina || !state.municipioSelected) {
      notification.showNotification(
        "warning",
        "Aviso",
        "Todos los campos son requeridos.",
        null,
        4,
      );
      return;
    }
    setLoader(true);
    const body = {
      clave_municipio: state.municipioSelected.IDENTIFICADOR,
      municipio: state.municipioSelected.DESCRIPCION,
      oficina: state.oficina,
      clave_oficina: state.claveOficina,
    };
    const method = state.isEditing ? "PUT" : "POST";
    const url = state.isEditing
      ? `${urlPutOfic}/${state.idOficina}`
      : urlPostOfi;
    const response = await services(method, url, body);
    setLoader(false);
    if (response.status !== 200) {
      notification.showNotification(
        "error",
        response?.status,
        response?.error,
        null,
        4,
      );
      return;
    }
    notification.showNotification(
      "success",
      "Exito",
      response?.data?.mensaje,
      null,
      4,
    );
    cargarDatos(state?.municipioFilter?.IDENTIFICADOR);
    handleCloseModal();
  };

  const openEditModal = (index) => {
    const { ID, IDENTIFICADOR, DESCRIPCION, C_MUNICIPIO, MUNICIPIO } =
      state.oficinas[index];
    setState((prevState) => ({
      ...prevState,
      showModal: true,
      isEditing: true,
      claveOficina: IDENTIFICADOR,
      idOficina: ID,
      oficina: DESCRIPCION,
      municipioSelected: {
        DESCRIPCION: MUNICIPIO,
        IDENTIFICADOR: C_MUNICIPIO,
      },
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "claveOficina") {
      if (value.length > 5) return;
      if (!/^[0-9]*$/.test(value)) return;
    }

    if (name === "oficina") {
      if (!/^[a-zA-Z0-9_\-]*$/.test(value)) return;
    }

    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleSelectChange = (input) => {
    setState((prevState) => ({
      ...prevState,
      municipioSelected: input,
    }));
  };

  const handleOpenModal = () => {
    setState((prevState) => ({
      ...prevState,
      showModal: true,
    }));
  };

  const handleCloseModal = () => {
    setState((prevState) => ({
      ...prevState,
      municipioSelected: "",
      oficina: "",
      claveOficina: "",
      idOficina: "",
      isEditing: false,
      showModal: false,
    }));
  };

  const handleOpenModalDel = (index) => {
    setState((prevState) => ({
      ...prevState,
      showModalDel: true,
      oficinaDel: state.oficinas[index],
    }));
  };

  const handleCloseModalDel = () => {
    setState((prevState) => ({
      ...prevState,
      showModalDel: false,
      oficinaDel: "",
    }));
  };

  const validarEdicion = (index) => {
    const { C_MUNICIPIO, MUNICIPIO } = state.oficinas[index];
    return C_MUNICIPIO && MUNICIPIO ? (
      <>
        <div
          style={{ height: 30, width: 30, zIndex: 0 }}
          className="cta cta--primary cta--icon icon_btn"
          onClick={() => openEditModal(index)}
        >
          <IconUI size={"20px"} color={"white"}>
            <AiOutlineEdit />
          </IconUI>
          <div className="icon_btn_help">Editar</div>
        </div>
        <div
          style={{ height: 30, width: 30, zIndex: 0, marginLeft: "3px" }}
          className="cta cta--primary cta--icon icon_btn"
          onClick={() => handleOpenModalDel(index)}
        >
          <IconUI size={"20px"} color={"white"}>
            <DeleteIcon />
          </IconUI>
          <div className="icon_btn_help">Eliminar</div>
        </div>
      </>
    ) : (
      ""
    );
  };

  const handleSelectMunicipiosChange = (input) => {
    const { IDENTIFICADOR } = input;
    setState((state) => ({
      ...state,
      municipioFilter: input,
    }));
    cargarDatos(IDENTIFICADOR);
  };

  const handleDeleteOficina = async (ID) => {
    setLoader(true);
    const response = await services("DELETE", `${urlDelOfic}/${ID}`);
    setLoader(false);
    if (response.status !== 200) {
      notification.showNotification(
        "error",
        response?.status,
        response?.data?.ES_MSJ?.V1_MENS,
        null,
        4,
      );
      return;
    }
    notification.showNotification(
      "success",
      "Exito",
      response?.data?.mensaje,
      null,
      4,
    );
    cargarDatos(state?.municipioFilter?.IDENTIFICADOR);
    handleCloseModalDel();
  };

  return {
    state,
    loader,
    columns,
    options,
    handleInputChange,
    handleOpenModal,
    handleCloseModal,
    handleCloseModalDel,
    handleSelectChange,
    handleCreate,
    handleSelectMunicipiosChange,
    handleDeleteOficina,
  };
};
